<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UXdR7E/tc-custom/FC-9781398400801.jpg?1685327173448?1725649954027" alt="This image is the cover for the book HeartScapes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">HeartScapes
      </h1>
      <p class="bookDescription body article font2">
        <p>Heartscapes explores ‘the greater love’ we see in people and the world around us. The ‘heart’ poems are the prayers of a contemplative set in the context of a long life that has known tragedy and suffering as well as love and many friendships. Heartscapes also includes salty wisdom about real life, love poems, stories, eco-poems, poems inspired by animals, translations, poems in memory of loved ones – and much more. It thus resonates with all the living, human and animate that I encounter, as well as the landscape and seascape we are blessed with in Aotearoa/New Zealand. Hand in hand with indigenous peoples, Maori, Aboriginal, Pacific, I’m trying to recover a sense of the sacred we have lost in our western science- and info-based culture.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Raymond Pelly
      </h2>
      
      <p class="authorDescription body article">Raymond Pelly is an Anglican Priest & theologian resident (since 1977) in Aotearoa, New Zealand. Born in London in 1938, where he experienced the Blitz, he has worked as a teacher in Cambridge (UK), Boston/Cambridge (MA), Auckland (NZ). He is married to Barbara Craig, father of six children, two deceased. His book, Pilgrim to Unholy Places, investigates the implications of the Holocaust for Jewish-Christian dialogue and belief generally. His Heartscape poems explore ‘deep mind’, the well-springs of passionate creativity and a strong love that embraces people as well as land and seascape. Raymond speaks French& German; some of his best writing has been done in Contemplative/Carmelite Communities in Berlin, Weimar, Dachau & Esterwegen/Emsland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?13405c8d